import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { GET_AUDIT_TICKETS, GET_EXPORT_AUDIT_TICKETS } from "./actionTypes"
import {
  getAuditTicktesSuccess,
  getAuditTicketsFail,
  getExportAuditTicketsFail,
  getExportAuditTicketsSuccess,
} from "./actions"

//Include Both Helper File with needed methods
import { getAuditTickets, getExportAuditTickets } from "helpers/backend_helper"

function* fetchAuditTickets({ payload }) {
  try {
    const response = yield call(getAuditTickets, payload)
    yield put(getAuditTicktesSuccess(response))
  } catch (error) {
    yield put(getAuditTicketsFail(error))
  }
}

function* fetchExportAuditTickets({ payload }) {
  try {
    const response = yield call(getExportAuditTickets, payload)
    yield put(getExportAuditTicketsSuccess(response))
  } catch (error) {
    yield put(getExportAuditTicketsFail(error))
  }
}

function* AuditSaga() {
  yield takeEvery(GET_AUDIT_TICKETS, fetchAuditTickets)
  yield takeEvery(GET_EXPORT_AUDIT_TICKETS, fetchExportAuditTickets)
}

export default AuditSaga
